
/* Protopia Ecosystem component */
export interface IEditorProps {
   children: JSX.Element[]
}
const Editor = (props: IEditorProps): JSX.Element => {
    return <div className='landing-editor-container'>
       <div className="label">{props.children}</div>
    </div>
}
export default Editor